export default "__VITE_ASSET__mNTqdbBl__"